import { useQuery } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'
import type { Alistamiento } from '@/lib/supabase/tipos-bd'

/**
 * Lo que bodega tiene que alistar, por orden de servicio (fn_alistamientos,
 * 0246): cada cotización con sus renglones de material y lo que hay en las
 * bodegas de World Office. Se refresca cada cinco minutos: las existencias
 * y las aceptaciones cambian solas.
 */
export function useAlistamientos() {
  return useQuery({
    queryKey: ['alistamientos'],
    queryFn: async (): Promise<Alistamiento[]> => {
      const { data, error } = await supabase.rpc('fn_alistamientos')
      if (error) throw new Error(mensajeDeError(error))
      return (data ?? []) as Alistamiento[]
    },
    refetchInterval: 5 * 60_000,
  })
}
